import React from "react";
import { css } from "@emotion/core";
import { PropagateLoader, BarLoader } from "react-spinners";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const Bar = props => {
  return (
    <div className="sweet-loading">
      <BarLoader
        css={override}
        sizeUnit={"%"}
        height={4}
        width={300}
        color={"#C2185B"}
        loading={props.loading}
      />
    </div>
  );
};

const Propagate = props => {
  return (
    <div className="sweet-loading">
      <PropagateLoader
        css={override}
        sizeUnit={"px"}
        size={15}
        color={"#C2185B"}
        loading={props.loading}
      />
    </div>
  );
};

// export default Loader;
export { Bar, Propagate };
